module.exports = {"TXTCLI_My_News":{"id":"TXTCLI_My_News","defaultMessage":"Τα νέα μου"}}